import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../base/Button/Button';

const CreateComplaintMenuItem = ({children, completed, name, onClick, selected, title}) => {
    
    const btnClass = classNames(
        "btn menu-btn",
        {"completed" : completed},
        {"selected" : selected}
    );

    return(
        <li className="menu-wrapper">
            <Button
                className={btnClass}
                name={name}
                onClick={onClick}
                title={title}>
                {children}
            </Button>
        </li>
    );
};

CreateComplaintMenuItem.propTypes = {
    children: PropTypes.node,
    completed: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    title: PropTypes.string
};

export default CreateComplaintMenuItem;


// WEBPACK FOOTER //
// ./src/components/CreateComplaintMenu/CreateComplaintMenuItem.js